import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { StatsJobEventFilter } from './stats-job-event.filter';
import { ResourceService } from '../shared/resource.service';
import { HttpClient } from '@angular/common/http';
import { StatsJobEventFilterSerializer } from './stats-job-event.filter.serializer';

@Injectable()
export class StatsJobEventFilterService extends ResourceService<StatsJobEventFilter> {
  baseUrl = environment.serverUrl;

  constructor(http: HttpClient) {
    super(http, 'jobevents/stats', new StatsJobEventFilterSerializer());
  }
}
